import { ETransactionPaymentStatuses } from 'src/interfaces/transactions';
import {
  STATUS_LABEL_TRANSACTION_APPROVED,
  STATUS_LABEL_TRANSACTION_PENDING,
  STATUS_LABEL_TRANSACTION_REJECTED,
  STATUS_LABEL_TRANSACTION_ANNULED,
  STATUS_LABEL_TRANSACTION_CANCELED,
  STATUS_LABEL_TRANSACTION_IN_PROCESS,
  STATUS_LABEL_TRANSACTION_REFUNDED,
  STATUS_LABEL_TRANSACTION_PARTIAL_REFUND,
  STATUS_PROMOTION_LABEL_FINISHED,
  STATUS_PROMOTION_LABEL_ACTIVE
} from 'src/global/theme/colors';
import { EPromotionCalculatedStatus } from 'src/interfaces/promotions';

export const StatusTransactionLabelColor = {
  [ETransactionPaymentStatuses.APPROVED]: STATUS_LABEL_TRANSACTION_APPROVED,
  [ETransactionPaymentStatuses.PENDING]: STATUS_LABEL_TRANSACTION_PENDING,
  [ETransactionPaymentStatuses.REJECTED]: STATUS_LABEL_TRANSACTION_REJECTED,
  [ETransactionPaymentStatuses.ANNULED]: STATUS_LABEL_TRANSACTION_ANNULED,
  [ETransactionPaymentStatuses.CANCELED]: STATUS_LABEL_TRANSACTION_CANCELED,
  [ETransactionPaymentStatuses.IN_PROCESS]: STATUS_LABEL_TRANSACTION_IN_PROCESS,
  [ETransactionPaymentStatuses.REFUNDED]: STATUS_LABEL_TRANSACTION_REFUNDED,
  [ETransactionPaymentStatuses.PARTIAL_REFUND]: STATUS_LABEL_TRANSACTION_PARTIAL_REFUND
};

export const StatusPromotionLabelColor = {
  [EPromotionCalculatedStatus.RUNNING]: STATUS_PROMOTION_LABEL_ACTIVE,
  [EPromotionCalculatedStatus.FINISHED]: STATUS_PROMOTION_LABEL_FINISHED,
  [EPromotionCalculatedStatus.VISIBLE_NOT_APPLICABLE]: STATUS_PROMOTION_LABEL_FINISHED,
};

export const enum PROMO_CALENDAR_STATUS_TAG {
  ACCUMULATIVE = 'Acumulable',
}

export const enum STORES_PROMOS_STATUS_TAG {
  STORE_FULL_CONTRIBUTION = 'Aporte 100% comercio',
}
